/**
 * ACRES User — Leaderboard
 */
import React, { useEffect, useState } from 'react';
import { acres } from '../../../lib/services/acresService';

export const AcresLeaderboardUser: React.FC<{ user?: any }> = () => {
  const [rows, setRows] = useState<any[]>([]);
  const [me, setMe] = useState<any>(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = async (p: number) => {
    setLoading(true); setError(null);
    try {
      const r = await acres.getLeaderboard(p, 50);
      setRows(r.users || r.rows || []);
      setMe(r.me || null);
      setHasMore(!!r.has_more);
      setPage(p);
    } catch (e: any) { setError(e?.message || 'Failed to load'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(1); }, []);

  if (loading) return <div style={{ color: '#9CA3AF' }}>Loading…</div>;
  if (error) return <div style={errBox}>{error}</div>;

  return (
    <div>
      {me && (
        <div style={{ ...card, marginBottom: 12, borderColor: '#F59E0B' }}>
          <div style={{ fontSize: 12, color: '#9CA3AF' }}>Your position</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 4 }}>
            <div style={{ fontWeight: 700, fontSize: 18, color: '#F59E0B' }}>#{me.rank} · {me.handle || 'you'}</div>
            <div style={{ fontSize: 13 }}>{Number(me.total_points || 0).toLocaleString()} pts · {me.tasks_completed || 0} tasks</div>
          </div>
        </div>
      )}

      <div style={{ overflowX: 'auto' }}>
        <table style={tableStyle}>
          <thead><tr style={trHead}>
            <th style={th}>#</th><th style={th}>User</th><th style={th}>Points</th><th style={th}>Tasks</th><th style={th}>Tier</th>
          </tr></thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.user_id || i} style={{ ...trBody, ...(me && me.user_id === r.user_id ? { background: 'rgba(245,158,11,0.06)' } : {}) }}>
                <td style={td}>{r.rank ?? ((page - 1) * 50 + i + 1)}</td>
                <td style={td}>{r.handle || `user#${r.user_id}`}</td>
                <td style={td}>{Number(r.total_points || 0).toLocaleString()}</td>
                <td style={td}>{r.tasks_completed || 0}</td>
                <td style={td}>{r.tier_name ? `${r.tier_icon || ''} ${r.tier_name}` : '—'}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={5} style={{ ...td, textAlign: 'center', color: '#9CA3AF' }}>No leaderboard data yet.</td></tr>}
          </tbody>
        </table>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 12 }}>
        <button disabled={page <= 1} onClick={() => load(page - 1)} style={{ ...btn, opacity: page <= 1 ? 0.4 : 1 }}>← Previous</button>
        <div style={{ color: '#9CA3AF', fontSize: 12, alignSelf: 'center' }}>Page {page}</div>
        <button disabled={!hasMore} onClick={() => load(page + 1)} style={{ ...btn, opacity: hasMore ? 1 : 0.4 }}>Next →</button>
      </div>
    </div>
  );
};

const tableStyle: React.CSSProperties = { width: '100%', borderCollapse: 'collapse', fontSize: 13 };
const trHead: React.CSSProperties = { background: '#1E1E1E' };
const trBody: React.CSSProperties = { borderBottom: '1px solid #1E1E1E' };
const th: React.CSSProperties = { padding: '8px 10px', textAlign: 'left', color: '#F59E0B', fontWeight: 600 };
const td: React.CSSProperties = { padding: '8px 10px' };
const card: React.CSSProperties = { background: '#0F0F0F', border: '1px solid #1E1E1E', borderRadius: 8, padding: 14 };
const btn: React.CSSProperties = { padding: '6px 14px', background: 'transparent', color: '#E5E7EB', border: '1px solid #374151', borderRadius: 6, cursor: 'pointer', fontSize: 13 };
const errBox: React.CSSProperties = { padding: 10, background: 'rgba(220,38,38,0.1)', border: '1px solid #DC2626', borderRadius: 6, color: '#FCA5A5' };
